import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { getConfig } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

import { AuthGuard } from 'src/auth/guard';
import { HRAuthGuard } from 'src/auth/guard/hr-guard';

import { usePathname } from '../hooks';

// ----------------------------------------------------------------------

const CandidatePage = lazy(() => import('src/pages/candidates'));
const CandidateDetailPage = lazy(() => import('src/pages/candidates').then(module => ({ 
  default: module.CandidateDetailWrapper 
})));
const NewCandidateDetailPage = lazy(() => import('src/pages/candidates/new-candidate-detail'));

// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
      <SuspenseOutlet />
  </DashboardLayout>
);

//TODO: Optimize Re-rendering of JobNavData

export function getCandidateRoutes(): RouteObject[] {
  const CONFIG = getConfig();

  return [
  {
    path: 'candidates',
    element: CONFIG.auth.skip ? (
      dashboardLayout()
    ) : (
      <AuthGuard>
        <HRAuthGuard>{dashboardLayout()}</HRAuthGuard>
      </AuthGuard>
    ),
    children: [
      { element: <CandidatePage />, index: true },
      { path: 'details', element: <CandidateDetailPage /> },
      { path: 'new-details', element: <NewCandidateDetailPage /> },
    ],
  },
  ];
}
